import { useBreakpointValue } from '@genial/utils';
import { RouteProp, useRoute } from '@react-navigation/native';
import React from 'react';

import { useRecoilQuery } from '../../../../../../hooks/useRecoilQuery';
import { CustomerDetailStackParamList } from '../../../../../../routes/types';
import { customerContractedProductsQuery } from '../../../../../../store/customerDetail/selector';
import { IContractedProductsNormalized } from '../../../../../../store/customerDetail/types';

import { ContractedProductsDesktop } from './Desktop';
import { ContractedProductsMobile } from './Mobile';

export namespace ContractedProductsTypes {
  export interface BaseProps {}
  export interface Props extends BaseProps {
    isLoading: boolean;
    products: IContractedProductsNormalized[];
  }
}

export const ContractedProducts: React.FC<ContractedProductsTypes.BaseProps> = (props) => {
  const route = useRoute<RouteProp<CustomerDetailStackParamList, 'CustomerDetail'>>();
  const { data, loading } = useRecoilQuery(
    customerContractedProductsQuery({ accountId: route.params.accountId })
  );

  const componentProps: ContractedProductsTypes.Props = {
    ...props,
    products: data?.data.contractedProductsAssetsNormalized || [],
    isLoading: loading,
  };

  const content = useBreakpointValue({
    base: <ContractedProductsMobile {...componentProps} />,
    sm: <ContractedProductsDesktop {...componentProps} />,
  });

  return content;
};
